export default import.meta.ROLLDOWN_FILE_URL_nK6CXoEFqAfGfhlY7WPU7g